import React from "react";
import "./file-toolbar.css";

function FileToolbar({
    newFolderOptions,
    uploadOptions,
    cutOptions,
    copyOptions,
    pasteOptions,
    duplicateOptions,
    deleteOptions,
    renameOptions,
    downloadOptions,
    refreshOptions,
    infoOptions,
    shareOptions,
    isSharedFolder
}) {
    const toolbarItems = {
        leftSide: [
            {
                options: {
                    show: hp.store.prms.canEdit && newFolderOptions,
                    disabled: (newFolderOptions?.disabled || isSharedFolder) ?? false,
                    icon: newFolderOptions?.icon ?? "la la-plus",
                    text: newFolderOptions?.text ?? "Nova Pasta",
                    onClick: newFolderOptions?.onItemClicked,
                },
            },
            {
                options: {
                    show: hp.store.prms.canEdit && uploadOptions,
                    disabled: (uploadOptions?.disabled || isSharedFolder) ?? false,
                    icon: uploadOptions?.icon ?? "la la-upload",
                    text: uploadOptions?.text ?? "Upload",
                    onClick: uploadOptions?.onItemClicked
                },
            },
            {
                options: {
                    show: hp.store.prms.canEdit && cutOptions ,
                    disabled: (cutOptions?.disabled || isSharedFolder) ?? false,
                    icon: cutOptions?.icon ?? "la la-cut",
                    text: cutOptions?.text ?? "Cortar",
                    onClick: cutOptions?.onItemClicked
                },
            },
            {
                options: {
                    show: hp.store.prms.canEdit && copyOptions,
                    disabled: copyOptions?.disabled ?? false,
                    icon: copyOptions?.icon ?? "la la-copy",
                    text: copyOptions?.text ?? "Copiar",
                    onClick: copyOptions?.onItemClicked
                },
            },
            {
                options: {
                    show: hp.store.prms.canEdit && pasteOptions,
                    disabled: (pasteOptions?.disabled || isSharedFolder) ?? false,
                    icon: pasteOptions?.icon ?? "la la-paste",
                    text: pasteOptions?.text ?? "Colar",
                    onClick: pasteOptions?.onItemClicked
                },
            },
            {
                options: {
                    show: hp.store.prms.canEdit && duplicateOptions,
                    disabled: (duplicateOptions?.disabled || isSharedFolder) ?? false,
                    icon: duplicateOptions?.icon ?? "la la-clone",
                    text: duplicateOptions?.text ?? "Duplicar",
                    onClick: duplicateOptions?.onItemClicked
                },
            },
            {
                options: {
                    show: hp.store.prms.canDelete && deleteOptions,
                    disabled: (deleteOptions?.disabled || isSharedFolder) ?? false,
                    icon: deleteOptions?.icon ?? "la la-trash",
                    text: deleteOptions?.text ?? "Apagar",
                    onClick: deleteOptions?.onItemClicked
                },
            },
            {
                options: {
                    show: hp.store.prms.canEdit && renameOptions,
                    disabled: (renameOptions?.disabled || isSharedFolder) ?? false,
                    icon: renameOptions?.icon ?? "la la-edit",
                    text: renameOptions?.text ?? "Renomear",
                    onClick: renameOptions?.onItemClicked
                },
            },
            {
                options: {
                    show: hp.store.prms.canRead && downloadOptions,
                    disabled: downloadOptions?.disabled ?? false,
                    icon: downloadOptions?.icon ?? "la la-download",
                    text: downloadOptions?.text ?? "Download",
                    onClick: downloadOptions?.onItemClicked
                },
            },
            {
                options: {
                    show: refreshOptions ?? false,
                    disabled: refreshOptions?.disabled ?? false,
                    icon: refreshOptions?.icon ?? "la la-sync",
                    text: refreshOptions?.text ?? "Atualizar",
                    onClick: refreshOptions?.onItemClicked
                },
            },
        ],
        rightSide: [
            {
                options: {
                    show: hp.store.prms.canEdit && shareOptions,
                    disabled: (shareOptions?.disabled || isSharedFolder) ?? false,
                    icon: shareOptions?.icon ?? "la la-share-square",
                    text: shareOptions?.text ?? "Partilhar",
                    onClick: shareOptions?.onItemClicked
                },
            },
            {
                options: {
                    show: infoOptions ?? false,
                    disabled: infoOptions?.disabled ?? false,
                    icon: infoOptions?.icon ?? "la la-info-circle",
                    text: infoOptions?.text ?? "Info",
                    onClick: infoOptions?.onItemClicked
                },
            }
        ],
    };

    return (
        <div className="file-toolbar">
            <div className="file-toolbar-left">
                {toolbarItems.leftSide.map(
                    (item, index) =>
                        item.options?.show && (
                            <button key={`leftSide-${index}`} onClick={item.options.onClick} disabled={item.options.disabled} title={item.options.text}>
                                <em className={ `file-toolbar-icon ${item.options.icon}`}></em>
                                <span className="file-toolbar-info">{item.options.text}</span>
                            </button>
                        )
                )}
            </div>
            <div className="file-toolbar-right">
                {toolbarItems.rightSide.map(
                    (item, index) =>
                        item.options?.show && (
                            <button key={`rightSide-${index}`} onClick={item.options.onClick} disabled={item.options.disabled} title={item.options.text}>
                                <em className={ `file-toolbar-icon ${item.options.icon}`}></em>
                                <span className="file-toolbar-info">{item.options.text}</span>
                            </button>
                        )
                )}
            </div>
        </div>
    );
}

export default FileToolbar;
